// application
import { AxiosResponse } from "axios";
import { MenuResponse } from "@models/response";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IScreensApi {
	abstract getScreens(): Promise<AxiosResponse<Result<MenuResponse[]>>>;
}
